/** Reads only files granted by a native file picker or OS drop event. */
export async function readNativeFile(path: string): Promise<File> {
  const { readFile } = await import('@tauri-apps/plugin-fs')
  const contents = await readFile(path)
  const name = path.split(/[/\\]/).pop() || 'file'
  const extension = name.split('.').pop()?.toLowerCase() || ''
  const types: Record<string, string> = {
    csv: 'text/csv',
    txt: 'text/plain',
    json: 'application/json',
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  }
  return new File([contents], name, {
    type: types[extension] || 'application/octet-stream',
  })
}

export async function pickNativeFiles(): Promise<File[]> {
  const { open } = await import('@tauri-apps/plugin-dialog')
  const selected = await open({
    multiple: true,
    directory: false,
    title: 'Attach files',
  })
  if (!selected) return []
  // Decode one native file at a time rather than copying several large
  // buffers onto the rendering thread together.
  const files: File[] = []
  for (const path of Array.isArray(selected) ? selected : [selected])
    files.push(await readNativeFile(path))
  return files
}
